import { DEFAULT_LIGHTS_CONFIG } from '../../../trillion-viewer/src/viewer/default-lights-config'
import { isDirectionalLightConfigDto } from '../dto/light-config.dto'
import { ReflectionMapDto } from '../dto/reflection-map.dto'
import { ViewerConfigDto } from '../dto/viewer-config.dto'
import { BaseConfig } from './base-config.object'
import { CameraRotation } from './camera-rotation.object'
import { BaseLightConfig, DirectionalLightConfig, LightConfig } from './light-config.object'
import { PointOfView } from './point-of-view.object'

export class ViewerConfig extends BaseConfig {
  readonly pointsOfView: Array<PointOfView>
  readonly lights: Array<LightConfig>
  readonly cameraRotation?: CameraRotation
  readonly viewerReflectionMap?: ReflectionMapDto

  constructor(viewerConfigDto: ViewerConfigDto) {
    super(viewerConfigDto)
    this.pointsOfView = viewerConfigDto.pointsOfView.map(
      (pointOfViewDto) => new PointOfView(pointOfViewDto),
    )
    const lights = (viewerConfigDto.lights && viewerConfigDto.lights.length > 0) ? 
      viewerConfigDto.lights : 
      DEFAULT_LIGHTS_CONFIG

    this.lights = lights.map(
      (lightConfigDto) => isDirectionalLightConfigDto(lightConfigDto) ? 
        new DirectionalLightConfig(lightConfigDto) : 
        new BaseLightConfig(lightConfigDto),
    )

    this.cameraRotation = viewerConfigDto.cameraRotation
  
    this.viewerReflectionMap = viewerConfigDto.viewerReflectionMap
  }
}
